import React from 'react'
import './About.css'
import { motion } from 'framer-motion'
import { images } from '../../constants'

const About = () => {
  const imageAnimate = {
    offscreen: { x: -50, opacity: 0 },
    onscreen: {
      x: 0,
      opacity: 1,
      rotate: [0, 10, 0],
      transition: { type: 'spring', bounce: 0.4, duration: 1 },
    },
  }
  const textAnimate = {
    offscreen: { y: 50, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', bounce: 0.4, duration: 2 },
    },
  }
  return (
    <motion.div
      className="about-bg d-flex justify-content-center align-items-center mt-5 mb-5"
      id="about"
      initial={'offscreen'}
      whileInView={'onscreen'}
      viewport={{ once: true, amount: 0.5 }}
      transition={{ staggerChildren: 0.5 }}
    >
      <div className="container-sm p-4">
        <motion.h1
          className="mb-5 mt-5"
          variants={textAnimate}
        >
          Fresh. Bold. Unforgettable.
        </motion.h1>
        <div className="row mt-5 mb-5 ">
          <div className="col-lg-5 d-flex justify-content-center">
            <motion.img
              src={images.about}
              className="img-fluid w-75 p-3"
              variants={imageAnimate}
            />
          </div>
          <div className="col-lg-5 row">
            <div className="d-flex justify-content-center align-items-center">
              <div className="justify-content-center align-items-center mt-5 mb-5">
                <motion.p variants={textAnimate}>
                  Sushi Edge serves a Japanese classic with a Kiwi touch.
                  Serving fresh, fast and healthy food is the main purpose at
                  Sushi Edge.
                </motion.p>
                <motion.p variants={textAnimate}>
                  Every day, our team members prepare over 60 different types of
                  sushi and meals, with great passion. We are proud to deliver
                  superior food to local people, to satisfy their demands, and
                  we are also extremely grateful for the trust and support from
                  our customers over the years. We will continue to serve our
                  customers with the same passion and remain true to our
                  original aspiration.
                </motion.p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default About
